import { useParams } from "react-router-dom";
import { useResolvedAuth } from "../hooks/useResolvedAuth";
import { PageLoader } from "../components/PageLoader/PageLoader";
import { OrganisationProfile } from "./OrganisationProfile";
import { PublicOrganisationDetail } from "./PublicOrganisationDetail";

export const UniversalOrganisationDetail = () => {
  const { organisationId } = useParams<{ organisationId: string }>();
  const { isAuthenticated, currentUser, isAuthResolving } = useResolvedAuth();

  if (isAuthResolving) {
    return <PageLoader />;
  }

  const isOwnProfile =
    isAuthenticated && currentUser?.userId === organisationId;

  if (isOwnProfile) {
    return <OrganisationProfile />;
  }

  return <PublicOrganisationDetail />;
};
